import { useSyncExternalStore } from 'react'
import { getBlockingState, subscribeBlocking, type BlockingPayload } from '../utils/blockingStore'

type BlockingSnapshot = BlockingPayload & {
  count: number
}

export const useBlockingStore = () => {
  return useSyncExternalStore<BlockingSnapshot>(
    subscribeBlocking,
    getBlockingState,
    () => ({ count: 0, title: undefined, description: undefined })
  )
}

